import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { NiceSelectModule } from "ng-nice-select";

import { ForgotPasswordRoutingModule } from '@teem/features/auth/forgot-password/forgot-password-routing.module';
import { SharedModule } from '@teem/shared/shared.module';
import { CoreModule } from '@teem/core/core.module';
import { ForgotPasswordComponent } from '@teem/features/auth/forgot-password/forgot-password.component';
// import { LoadingComponent } from '@teem/layouts/loading/loading.component';


@NgModule({
  declarations: [
    ForgotPasswordComponent,
    // LoadingComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
		ReactiveFormsModule,
    CoreModule,
    SharedModule,
    NgxPaginationModule,
    NiceSelectModule,
    ForgotPasswordRoutingModule
  ]
})
export class ForgotPasswordModule {
  
 }
